<template>
    <div class="w-full">
        <SearchBar @update-filters="updateFilters" @clear-filters="clearFilters" @add-click="openAddNewOneDialog"
            @update-advance-filters="updateAdvanceFiltersHandler">
        </SearchBar>
        <div class="flex flex-wrap items-center gap-x-6 gap-y-2 py-2">
            <v-checkbox
                v-model="filters.onlyFingerPrint"
                label="OS / IP Fingerprint Spoofing"
                density="compact"
                hide-details
            />
            <v-checkbox
                v-model="filters.onlySocksUdp"
                label="Socks UDP"
                density="compact"
                hide-details
            />
        </div>
        <div v-if="selectedUuids.length > 0" class="flex flex-wrap items-center gap-2 py-2 bg-white border px-3">
            <span class="text-sm font-semibold">Selected: {{ selectedUuids.length }}</span>
            <v-btn size="small" class="bg-dark text-light" @click="bulkSetFingerPrint(true)">Enable Fingerprint</v-btn>
            <v-btn size="small" class="bg-dark text-light" @click="bulkSetFingerPrint(false)">Disable Fingerprint</v-btn>
            <v-btn size="small" class="bg-dark text-light" @click="bulkSetSocksUdp(true)">Enable Socks UDP</v-btn>
            <v-btn size="small" class="bg-dark text-light" @click="bulkSetSocksUdp(false)">Disable Socks UDP</v-btn>
            <v-btn size="small" color="error" variant="flat" @click="bulkDelete">Delete Selected</v-btn>
            <v-btn size="small" variant="text" @click="selectedUuids = []">Clear selection</v-btn>
        </div>
        <v-btn-toggle v-model="viewType" color="deep-purple-accent-3 " rounded="0" group class="border-b-none border"
            mandatory>
            <v-btn value="table" class="bg-white text-black">
                Table
            </v-btn>
            <v-btn value="graph" class="bg-white text-black ">
                Graph
            </v-btn>
        </v-btn-toggle>
        <TableView
            v-if="viewType === 'table'"
            :serverList="serverList"
            :selected="selectedUuids"
            @update:selected="selectedUuids = $event"
            class="border " />
        <GraphView :filters="filters" v-else-if="viewType === 'graph'" class="border bg-white text-black" />
    </div>
    <div>
        <AddNewOneDialog @close="addNewOneDialogFlag = false" />
    </div>
</template>
<script setup>
import { ref, watch } from 'vue';
import { useAdminServerStore } from "@/stores"

import AddNewOneDialog from "./Modals/AddNewOneDialog.vue"

import { storeToRefs } from 'pinia';

import SearchBar from './SearchBar.vue';
// import AddNewOneDialog from "./Modals/AddNewOneDialog.vue"
// import UpdateInfoDialog from "./Modals/UpdateInfoDialog.vue"
const viewType = ref("table")
import GraphView from "./GraphView.vue"
import TableView from "./TableView.vue"
import { useAlertStore } from "@/stores"
const filters = ref({
    searchFilterName: "",
    searchFilterLocation: "",
    searchFilterDomain: "",
    // Checkbox filters: checked => only true, unchecked => show all
    onlyFingerPrint: false,
    onlySocksUdp: false,
})

const applyFilters = (baseList = servers.value) => {
    const { searchFilterName, searchFilterLocation, searchFilterDomain, onlyFingerPrint, onlySocksUdp } = filters.value;

    const nameFilters = (searchFilterName || "").toLowerCase().split(' ').filter(Boolean);
    const locationFilters = (searchFilterLocation || "").toLowerCase().split(' ').filter(Boolean);
    const domainFilters = (searchFilterDomain || "").toLowerCase().split(' ').filter(Boolean);

    serverList.value = (baseList || []).filter(server => {
        const modemName = (server?.modemName || "").toLowerCase();
        const country = (server?.country || "").toLowerCase();
        const city = (server?.city || "").toLowerCase();
        const domain = (server?.domain || "").toLowerCase();

        const nameMatches = nameFilters.every(filter => modemName.includes(filter));
        const locationMatches = locationFilters.every(filter => country.includes(filter) || city.includes(filter));
        const domainMatches = domainFilters.every(filter => domain.includes(filter));

        const fingerPrintMatches = !onlyFingerPrint || server?.is_finger_print === true;
        const socksUdpMatches = !onlySocksUdp || server?.is_socks_udp === true;

        return nameMatches && locationMatches && domainMatches && fingerPrintMatches && socksUdpMatches;
    });
};

const updateFilters = (filtername, value) => {
    filters.value[filtername] = value
    applyFilters()
};
const clearFilters = () => {
    // Clear the search filter values
    filters.value.searchFilterName = ""
    filters.value.searchFilterLocation = ""
    filters.value.searchFilterDomain = ""
    filters.value.onlyFingerPrint = false
    filters.value.onlySocksUdp = false
    applyFilters()
};

const adminServerStore = useAdminServerStore()
const { servers } = storeToRefs(adminServerStore)
const serverList = ref(null)
adminServerStore.loadServers()
const addNewOneDialogFlag = ref(false)
const selectedUuids = ref([])

const openAddNewOneDialog = () => {
    addNewOneDialogFlag.value = true
}

const updateAdvanceFiltersHandler = (filters) => {
    const advancedFiltered = servers.value.filter(server =>
        server.domain.toLowerCase().includes(filters.domain.toLowerCase()) &&
        server.isp.toLowerCase().includes(filters.isp.toLowerCase()) &&
        (server.country.toLowerCase().includes(filters.location.toLowerCase()) ||
            server.city.toLowerCase().includes(filters.location.toLowerCase())
        ) &&
        server.modemName.toLowerCase().includes(filters.modemName.toLowerCase()) &&
        server.modem_type.toLowerCase() === (filters.modemType.toLowerCase())
    )
    applyFilters(advancedFiltered)
}

watch(
    () => [servers.value, filters.value.onlyFingerPrint, filters.value.onlySocksUdp],
    () => {
        applyFilters()
    },
    { immediate: true }
)

const bulkSetFingerPrint = async (value) => {
    const alertStore = useAlertStore()
    if (!selectedUuids.value?.length) return
    await adminServerStore.bulkUpdateFlags(selectedUuids.value, { is_finger_print: value })
    alertStore.success(`Fingerprint updated for ${selectedUuids.value.length} server(s)`)
}

const bulkSetSocksUdp = async (value) => {
    const alertStore = useAlertStore()
    if (!selectedUuids.value?.length) return
    await adminServerStore.bulkUpdateFlags(selectedUuids.value, { is_socks_udp: value })
    alertStore.success(`Socks UDP updated for ${selectedUuids.value.length} server(s)`)
}

const bulkDelete = async () => {
    const alertStore = useAlertStore()
    if (!selectedUuids.value?.length) return
    const ok = window.confirm(`Delete ${selectedUuids.value.length} server(s)? This cannot be undone.`)
    if (!ok) return
    const res = await adminServerStore.bulkDeleteServers(selectedUuids.value)
    selectedUuids.value = []
    if (res?.skippedUuids?.length) {
        alertStore.warning(`Deleted ${res.deletedUuids?.length || 0}. Skipped ${res.skippedUuids.length} used server(s).`)
    } else {
        alertStore.success(`Deleted ${res?.deletedUuids?.length || 0} server(s).`)
    }
}


</script>